import colors from "@digits-shared/themes/colors"
import styled, { css } from "styled-components"
import {
  COMPONENT_TRANSITION_DURATION,
  DELETE_COMPONENT_SHRINK_KEYFRAMES,
} from "src/frontend/components/OS/Applications/Reports/Report/Viewer/Layout/LayoutViewer/DeleteAnimation"
import {
  ConfigComponentContainer,
  ROW_LANDSCAPE_WIDTH,
} from "src/frontend/components/OS/Applications/Reports/Report/Viewer/Layout/Shared"
import { ComponentWrapper as SharedComponentWrapper } from "src/frontend/components/Shared/Layout/Shared"
import { DeleteComponentStep } from "src/frontend/components/Shared/Layout/types"

export const COMPONENT_HEIGHT = 180

export const ComponentWrapper = styled(SharedComponentWrapper)<{
  isDragging?: boolean
  isOverlay?: boolean
  isDisabled?: boolean
  width: number
  deleteAnimationStep?: DeleteComponentStep
}>`
  ${({ isOverlay }) => css`
    ${isOverlay &&
    css`
      ${ConfigComponentContainer} {
        box-shadow: 0 0 20px ${colors.translucentBlack40};
      }
    `}
  `};

  ${({ isDragging, deleteAnimationStep }) =>
    !isDragging &&
    deleteAnimationStep === DeleteComponentStep.Shrink &&
    css`
      animation: ${DELETE_COMPONENT_SHRINK_KEYFRAMES} ${COMPONENT_TRANSITION_DURATION}ms both;
    `};

  @media print {
    [orientation="landscape"] & {
      min-width: ${ROW_LANDSCAPE_WIDTH}px;
    }
  }
`
